export default __webpack_public_path__ + "static/media/textImg.ba94f72e.svg";